import { render } from "./FiveCircleBookPreface.vue?vue&type=template&id=5cbf7234"
const script = {}

import "./FiveCircleBookPreface.vue?vue&type=style&index=0&id=5cbf7234&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__